module.exports = __webpack_public_path__ + "efff18c725c0e65abe016104a1175f4f.jpg";